import React from "react"
import { Grid, GridProps, Typography } from "@mui/material"
import { Button, Img, ImgProps } from "../../.."
import { PostType, TagType } from "../../../../types"
import { formatDate } from "../../../../helpers"
import { useStyles } from "./Post.styles"

export interface PostProps extends GridProps {
    post?: PostType
    tag?: TagType
    fullWidth?: boolean
    imageProps?: ImgProps
}

export function Post({ post, tag, fullWidth = false, imageProps, className, ...rest }: PostProps) {
    const { classes, cx } = useStyles()
    const {
        name,
        featuredImage,
        slug,
        metaDescription,
        publishDate,
    } = post || {}

    const { name: tagName, id: tagId, created: tagCreatedDate } = tag || {}

    return (
        <Grid container {...rest} className={cx(classes.root, { [classes.fullWidth]: fullWidth }, className)}>
            <Grid item xs={fullWidth ? 5 : 12} className={cx(classes.imageContainer, { [classes.fullWidth]: fullWidth })}>
                <Img src={featuredImage} {...imageProps} />
            </Grid>
            <Grid item xs={fullWidth ? 7 : 12}>
                <Grid container className={cx(classes.subContainer, { [classes.fullWidth]: fullWidth })}>
                    <Grid item xs={12}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            className={cx(classes.postHeader, { [classes.fullWidth]: fullWidth })}
                        >
                            <Typography className={cx(classes.tag, { [classes.fullWidth]: fullWidth })}>
                                {(tagName || '').toUpperCase()}
                            </Typography>
                            <Typography className={cx(classes.date, { [classes.fullWidth]: fullWidth })}>
                                {formatDate(publishDate) || 'Sin especificar'}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={cx(classes.title, { [classes.fullWidth]: fullWidth })}>
                            {name || 'Sin titulo'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={cx(classes.description, { [classes.fullWidth]: fullWidth })}>
                            {metaDescription || 'Sin descripción'}
                        </Typography>
                    </Grid>
                    {fullWidth && (
                        <Grid
                            item
                            xs={12}
                            className={cx(classes.actionsWrapper)}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                className={cx(classes.actionsContainer, { [classes.fullWidth]: fullWidth })}
                            >
                                <Button
                                    to={`/blog/${slug}`}
                                    variant="text"
                                    color="primary"
                                    className={classes.readMoreButton}
                                >
                                    Leer más
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>
            {!fullWidth && (
                <Grid
                    item
                    xs={12}
                    className={classes.actionsWrapper}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        className={classes.actionsContainer}
                    >
                        <Button to={`/blog/${slug}`} variant="text" color="primary">
                            Leer más
                        </Button>
                    </Grid>
                </Grid>
            )}
        </Grid>
    )
}